import { IconInfo } from "@synthesis/shared-icons";
import { Tooltip } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";
import type { ReactNode } from "react";

type MonitoringSectionHeadingProps = {
  title: string;
  tooltipTitle: string;
  tooltipDescription: string;
  actions?: ReactNode;
  className?: string;
};

const TooltipMultiline = ({ text }: { text: string }) => (
  <>
    {text.split("\n").map((line, index) => (
      <span key={index}>
        {index > 0 ? <br /> : null}
        {line}
      </span>
    ))}
  </>
);

export const MonitoringSectionHeading = ({ title, tooltipTitle, tooltipDescription, actions, className }: MonitoringSectionHeadingProps) => (
  <div className={cn("flex items-center justify-between gap-4 px-6", className)}>
    <div className="flex items-center gap-3">
      <h2 className="heading-h4 text-type-common">{title}</h2>
      <Tooltip
        title={tooltipTitle}
        description={<TooltipMultiline text={tooltipDescription} />}
        arrowSide="top"
        arrowAlign="start"
        size="sm"
        maxWidth="40rem"
      >
        <button type="button" className="flex size-6 shrink-0 -translate-y-0.5 items-center justify-center" aria-label={`Подсказка: ${title}`}>
          <IconInfo className="text-neutrals-60 size-6" aria-hidden />
        </button>
      </Tooltip>
    </div>
    {actions}
  </div>
);
